import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Полная тема Aura. Отличия от пресета: основная палитра blue (решение владельца, ADR 2026-09-03 «Уточнение 2026-10-06:
// новый дизайн на полной Aura», PAR-12961; синий — основной цвет панели со времён PrimeNG 17, aura-light-blue, #3B82F6 =
// blue-500, у самой Aura основной цвет emerald) и ключи `components` ниже. Любой другой ключ preset — переопределение
// (то же уточнение ADR): только записью-исключением check:overrides с причиной; вид меняется входами компонентов и
// утилитами раскладки.
export const THEME_PRESET = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  // Содержимое вкладок — без отступов слева и справа: начинается и кончается по краям линии под заголовками вкладок,
  // а не «лесенкой» внутри отступов страницы или попапа (решение владельца на холсте PAR-12964, 2026-10-06; запись
  // в check-primeng-overrides.exceptions.json). Вертикальные отступы — как у Aura (0.75rem сверху, 1rem снизу).
  components: {
    tabs: {
      tabpanel: {
        padding: '0.75rem 0 1rem 0',
      },
    },
    // Чипы выбранных значений в p-multiselect display="chip" не меняют высоту поля: чип ростом в одну строку текста
    // поля (1lh), подпись и крестик мельче, вертикальные отступы поля — те же, что без чипов (решение владельца на
    // холсте PAR-12964, 2026-10-06: фильтр состояний заказов и форматы в попапе мета-описания; запись
    // в check-primeng-overrides.exceptions.json). Токенами не выражается: у Aura вертикальный отступ чипа внутри поля
    // и отступ поля с чипами — половина multiselect.padding.y без своего токена, токены chip.* их не меняют; равенство
    // высот токенами потребовало бы подписи чипа 8px (size="small") или 14px (обычный размер). Охват — только чипы
    // внутри p-multiselect. Поле поиска в списке маленького p-multiselect — того же размера, что поле (у p-select размер
    // передаётся полю поиска входом pSize, у p-multiselect PrimeNG 22 — нет; решение владельца на холсте PAR-12965,
    // 2026-10-07). Список по умолчанию открывается внутри хоста (appendTo self), поэтому охват — .p-multiselect-sm.
    multiselect: {
      css: `
        .p-multiselect-display-chip .p-multiselect-label:has(.p-multiselect-chip) {
          padding-block: var(--p-multiselect-padding-y);
        }
        .p-multiselect-display-chip.p-multiselect-sm .p-multiselect-label:has(.p-multiselect-chip) {
          padding-block: var(--p-multiselect-sm-padding-y);
        }
        .p-multiselect-display-chip .p-multiselect-chip-item {
          display: flex;
        }
        .p-multiselect-display-chip .p-multiselect-label .p-multiselect-chip {
          padding-block: 0;
          min-height: 1lh;
        }
        .p-multiselect-display-chip .p-multiselect-chip .p-chip-label {
          font-size: 0.6875rem;
        }
        .p-multiselect-display-chip .p-multiselect-chip .p-chip-remove-icon {
          font-size: 0.625rem;
          width: 0.625rem;
          height: 0.625rem;
        }
        .p-multiselect-sm .p-multiselect-filter {
          font-size: var(--p-inputtext-sm-font-size);
          padding-block: var(--p-inputtext-sm-padding-y);
          padding-inline: var(--p-inputtext-sm-padding-x);
        }
      `,
    },
  },
});
